export default __webpack_public_path__ + "static/media/cardCover.5451d55b.svg";